<div class="flex items-center justify-center min-h-full p-4 relative">
    <div class="w-full max-w-xs">
      <div class="text-center mb-8">
         <h1 class="text-3xl font-bold text-white font-brand tracking-wider">
          <i class="fa-solid fa-leaf mr-2 text-emerald-400"></i>
          CHUAMKAN
        </h1>
        <p class="text-slate-400 mt-2">{{ 'pinLogin.title' | translate }}</p>
      </div>
  
      @if (isVerifyingSession()) {
         <div class="bg-slate-800/80 backdrop-blur-sm shadow-2xl rounded-2xl p-8 text-center border border-slate-700">
            <i class="fa-solid fa-circle-notch animate-spin text-4xl text-emerald-500 mb-4"></i>
            <h3 class="text-lg font-bold text-white mb-2">กำลังยืนยันตัวตน...</h3>
            <p class="text-slate-400 text-sm mb-6">กรุณารอสักครู่ ระบบกำลังโหลดข้อมูลของคุณ</p>
            
            <!-- NEW: Emergency Link if loading takes too long -->
            <button (click)="resetDeviceData()" class="text-xs text-slate-500 hover:text-red-400 underline flex items-center justify-center gap-2 mx-auto">
                <i class="fa-solid fa-rotate-right"></i>
                ถ้ารอนานเกินไป กดล้างข้อมูลที่นี่
            </button>
         </div>
      } @else {
          <div class="bg-slate-800/80 backdrop-blur-sm shadow-2xl rounded-2xl p-6 relative overflow-hidden transition-all duration-300"
               [class.border-2]="showResetSuggestion() || !isDeviceSetup()" 
               [class.border-red-500]="showResetSuggestion() || !isDeviceSetup()">
            
            <div class="w-full h-16 bg-slate-900 rounded-lg flex items-center justify-center mb-6">
                <p class="text-4xl font-mono tracking-[0.5em] text-center" [class]="error() ? 'text-red-400 animate-shake' : 'text-slate-300'">
                    {{ pinDisplay() }}
                </p>
            </div>

            <div class="grid grid-cols-3 gap-3">
                @for(key of keypad; track key) {
                    <button 
                        (click)="handleKeyPress(key)"
                        [disabled]="isLoading()"
                        [class.opacity-50]="!isDeviceSetup()"
                        class="h-16 text-2xl font-bold rounded-lg transition-colors flex items-center justify-center
                               bg-slate-700 hover:bg-slate-600
                               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-800 focus:ring-emerald-500
                               disabled:opacity-50">
                        @if (key === '<') {
                            <i class="fa-solid fa-delete-left"></i>
                        } @else {
                            {{ key }}
                        }
                    </button>
                }
            </div>

            @if (isLoading()) {
                <div class="text-center text-slate-400 mt-4 h-5">
                    <i class="fa-solid fa-spinner animate-spin mr-2"></i> {{ 'pinLogin.checkingPin' | translate }}
                </div>
            } @else if(error()) {
                <div class="text-center text-red-400 mt-4 h-5 text-sm font-bold">
                    {{ error() }}
                </div>
            } @else if (!isDeviceSetup()) {
                 <div class="text-center text-red-400 mt-4 h-5 text-xs font-bold animate-pulse">
                    <i class="fa-solid fa-triangle-exclamation mr-1"></i> ยังไม่ได้ผูกร้านค้า (Login Email First)
                </div>
            } @else {
                <div class="h-5 mt-4"></div>
            }
          </div>

          @if(showResetSuggestion()) {
            <div class="mt-4 bg-red-900/80 border border-red-500 rounded-lg p-3 text-center animate-bounce-in">
                <p class="text-white text-sm font-bold mb-2">⚠ พบปัญหาการเชื่อมต่อ</p>
                <p class="text-red-200 text-xs mb-3">ต้องการล้างข้อมูลและเริ่มใหม่หรือไม่?</p>
                <button (click)="resetDeviceData()" class="bg-red-600 hover:bg-red-500 text-white text-xs font-bold py-2 px-4 rounded-full w-full">
                    ล้างข้อมูลและเริ่มใหม่
                </button>
            </div>
          }

          <div class="text-center mt-6 flex flex-col gap-4">
            <a routerLink="/login" class="text-sm text-emerald-400 hover:text-emerald-300 transition-colors font-semibold">
                <i class="fa-solid fa-user-shield"></i> {{ isDeviceSetup() ? ('pinLogin.adminLoginLink' | translate) : 'ล็อกอินด้วยอีเมล (Admin Login)' }}
            </a>

            @if(!showResetSuggestion()) {
                <button (click)="resetDeviceData()" class="text-xs text-slate-500 hover:text-emerald-400 transition-colors underline flex items-center justify-center gap-2 mx-auto">
                    <i class="fa-solid fa-sync-alt"></i> 
                    {{ isDeviceSetup() ? 'ต้องการเปลี่ยนอีเมลหรือร้านค้า? กดที่นี่' : 'ล้างข้อมูลเครื่องและเริ่มต้นใหม่ (Reset)' }}
                </button>
            }
          </div>
      }
    </div>
</div>

<app-confirmation-modal
  [isOpen]="confirmModalState().isOpen"
  [title]="confirmModalState().title"
  [message]="confirmModalState().message"
  [confirmButtonText]="confirmModalState().confirmButtonText"
  [confirmButtonClass]="confirmModalState().confirmButtonClass"
  (confirm)="onConfirmAction()"
  (cancel)="closeConfirmModal()">
</app-confirmation-modal>

<style>
.animate-shake {
    animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}
@keyframes shake {
    10%, 90% { transform: translate3d(-1px, 0, 0); }
    20%, 80% { transform: translate3d(2px, 0, 0); }
    30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
    40%, 60% { transform: translate3d(4px, 0, 0); }
}
.animate-bounce-in {
    animation: bounceIn 0.5s;
}
@keyframes bounceIn {
  0% { transform: scale(0.8); opacity: 0; }
  60% { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(1); }
}
</style>